import { Slider } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IHoursProps {
    minutes: number
    onChange: (minutes: number) => void
}
const Minutes = ({minutes, ...props}: IHoursProps): JSX.Element => { 
    const onChange = (h: number ) => {  
        props.onChange( h )
    }
    return <div className="time-container">
        <div className="small letter-spacing-2">
            {__("Minutes")}
        </div>
        <Slider
            min={ 0 }
            max={ 60 }
            stepSize={ 1 }
            labelStepSize={ 10 }
            value={ minutes }
            onChange={ onChange }
            className="my-2  slider-width"
        />
    </div>
}
export default Minutes